"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.degreesToMeters = exports.metersToDegrees = exports.degreesToMetresFactor = void 0;
const turf_1 = require("@turf/turf");
/**
 * Account for earth being a sphere when converting from degrees into meters.
 * Consider near the poles: a single degree of longitude is less distance in meters
 * than a single degree of longitude is at the equator.
 * This function returns two numbers that can be multiplied by a number in degrees to
 * calculate the equivalent number of meters.
 *
 * @param locationDegrees A reference location measured in degrees
 * @returns How much to scale 1 degree by to convert it to meters. Provides a value for X and Y
 */
function degreesToMetresFactor(locationDegrees) {
    const degreesToMetresY = 1 / (0, turf_1.lengthToDegrees)(1, 'meters');
    const degreesToMetresX = degreesToMetresY * Math.cos((Math.PI / 180) * locationDegrees[1]);
    return [degreesToMetresX, degreesToMetresY];
}
exports.degreesToMetresFactor = degreesToMetresFactor;
/**
 * Account for the earth being a sphere when converting from meters into degrees.
 * Consider near the poles: a single degree of longitude is less distance in meters
 * than a single degree of longitude is at the equator.
 * This function takes in both a reference position and a vector in meters that you wish
 * to convert to a vector in degrees
 *
 * @param referencePositionDegrees A reference position measured in degrees
 * @param distanceMeters A direction vector measured in meters
 * @returns A direction vector measured in degrees
 */
function metersToDegrees(referencePositionDegrees, distanceMeters) {
    const [degreesToMetersX, degreesToMetersY] = degreesToMetresFactor(referencePositionDegrees);
    const degreesX = distanceMeters[0] / degreesToMetersX;
    const degreesY = distanceMeters[1] / degreesToMetersY;
    return [degreesX, degreesY];
}
exports.metersToDegrees = metersToDegrees;
/**
 * Account for the earth being a sphere when converting from meters into degrees.
 * Consider near the poles: a single degree of longitude is less distance in meters
 * than a single degree of longitude is at the equator.
 * This function takes in both a reference position and a vector in degrees that you wish
 * to convert to a vector in meters
 *
 *
 * @param referencePositionDegrees A reference position measured in degrees
 * @param distanceDegrees A direction vector measured in degrees
 * @returns A direction vector measured in meters
 */
function degreesToMeters(referencePositionDegrees, distanceDegrees) {
    const [degreesToMetersX, degreesToMetersY] = degreesToMetresFactor(referencePositionDegrees);
    const degreesX = distanceDegrees[0] * degreesToMetersX;
    const degreesY = distanceDegrees[1] * degreesToMetersY;
    return [degreesX, degreesY];
}
exports.degreesToMeters = degreesToMeters;
